export default __webpack_public_path__ + "static/media/roppongi-dusk-to-dark-cropped.d436cee8.jpg";